const businessFaq = [
  {
    id: 1,
    category: "Identity & Badges",
    question: "What do the different checkmarks mean?",
    answer:
      "• Gold Badge 🟡: This is for verified Business Entities and Physical Stores. It requires official document approval from SoloChat.\n• Green Badge 🟢: This is for Official Retailers, Support accounts, and influencers who have been authenticated by the system.\n• Blue Badge 🔵: This is for our Premium Subscribers. It shows you are a supporter of the platform and unlocks all pro features.",
  },
  {
    id: 2,
    category: "Identity & Badges",
    question: "How do I get a Gold Business badge?",
    answer:
      "Go to your Profile > Business Tools and tap \"Apply for Verified Business.\" Your request will be sent to our admin team for review. You must have an active SoloChat Premium subscription.",
  },
  {
    id: 3,
    category: "Storefront & Discovery",
    question: "How does the \"Physical Address\" work?",
    answer:
      "In your Business Tools, you can drop a pin on the map exactly where your shop is located. When customers view your profile, they will see a \"Get Directions\" button that opens their GPS (Google Maps or Apple Maps) to lead them straight to your door.",
  },
  {
    id: 4,
    category: "Storefront & Discovery",
    question: "What are Video Categories?",
    answer:
      "When you post a Minute Video, you can tag it as \"Food,\" \"Real Estate,\" \"Fashion,\" etc. Users on the Discovery Map can filter by these categories to find exactly what they are looking for nearby.",
  },
  {
    id: 5,
    category: "Storefront & Discovery",
    question: "How do I show my \"Video Menu\"?",
    answer:
      "Simply post a video and tag it with your business category. On the map, when someone taps your shop's pin, your latest video in that category will automatically play, acting as a visual greeting or digital menu.",
  },
  {
    id: 6,
    category: "Smart Automation",
    question: "What is the \"Auto-Reply Bot\"?",
    answer:
      "It's a 24/7 smart assistant. Once enabled, it reads your profile info (hours, website, email) and automatically answers customer questions like \"Are you open?\" or \"What is your website?\" so you never miss a lead.",
  },
  {
    id: 7,
    category: "Smart Automation",
    question: "When are \"Away Messages\" sent?",
    answer:
      "If a customer messages you outside of the Working Hours you set in your profile, SoloChat will automatically send your custom \"Away Message\" to let them know when you'll be back.",
  },
  {
    id: 8,
    category: "Smart Automation",
    question: "What is a \"Fast Reply\"?",
    answer:
      "Instead of typing the same thing over and over, you can create shortcuts. For example, typing \"/thanks\" will instantly expand into your full, professional thank-you message.",
  },
  {
    id: 9,
    category: "Organizing Customers",
    question: "What are \"Chat Tags\"?",
    answer:
      "You can organize your inbox using color-coded tags like \"New Order,\" \"Pending Payment,\" or \"V.I.P.\" You can tag multiple people at once by long-pressing their chats in the inbox.",
  },
  {
    id: 10,
    category: "Organizing Customers",
    question: "Can I see only my \"Pending Payments\"?",
    answer:
      "Yes! Tap on the \"Labels\" tab in your chat list, or go to Business Tools > Chat Tags and tap on a specific category to see only those customers.",
  },
  {
    id: 11,
    category: "Earnings & Subscription",
    question: "How do I withdraw my money?",
    answer:
      "If you are a Premium member, you can go to the Marketplace and use the \"Withdraw Your Earnings\" tool to sell your earned coins for real cash via PayPal, Payoneer, or your Bank.",
  },
  {
    id: 12,
    category: "Earnings & Subscription",
    question: "What happens if my Premium expires?",
    answer:
      "To maintain trust, your professional badges (Gold/Green) and automation tools will be temporarily hidden until you renew your subscription. Your data (hours, links, tags) will be saved and restored once you renew.",
  },
  {
    id: 13,
    category: "Sharing Your Business",
    question: "How do I share my shop with others?",
    answer:
      "In your Business Tools, you'll find a \"Direct Chat Link.\" You can copy this link (solochat.me/chat/yourname) and put it in your Instagram bio or on your website. When customers click it, they will be taken directly into a chat with you!",
  },
];

export default businessFaq;
